/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sales_Owned_DebtInputs */

const vi_dashboard_sales_owned_debt = /** @type {(inputs: Dashboard_Sales_Owned_DebtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công nợ khách phụ trách`)
};

/**

* @param {Dashboard_Sales_Owned_DebtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_owned_debt = /** @type {((inputs?: Dashboard_Sales_Owned_DebtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_Owned_DebtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_owned_debt(inputs)
});